//********************************************//
//******************* ITEMS ******************//
//********************************************//

/*
|====================================== ITEMS UPDATE ================================|
|===========      updateItems (items, model, eraseOtherValues)           ============|
|====================================================================================|
|
|   items - GudHub items those we are going to be updated
|   eraseOtherValues - if is 'true' then we erase fields those are not going to be updated
|   model - by this model we update values. The model format should have folowing format:
|
|   
|   model = [
|    {
|       "element_id" : 228464,
|       "field_value" : 777
|    }]
|
|==================================================================================|
*/


//********************** UPDATE ITEMS ************************/
export default function populateItems(items, model, keep_data) {
  var itemsCopy = JSON.parse(JSON.stringify(items));
  if (keep_data) {
    return populateItemsAndKeepOtherValues(itemsCopy, model);
  } else {
    return populateItemsAndEraseOtherValues(itemsCopy, model);
  }
}


//---- Update Items And KEEP Other Values ----//
function populateItemsAndKeepOtherValues(items, model) {
  items.forEach(item => {
    model.forEach(modelField => {
      let field = item.fields.find(sourceField => sourceField.element_id == modelField.element_id);

      if (field) {
        field.field_value = modelField.field_value;
      } else {//-- if we didn't find field with item then we add it
        modelField.field_id = modelField.element_id; //backend send ERROR if don't send field_id
        item.fields.push(modelField);
      }
    });
  });

  return items;
}


//---- Update Items And ERASE Other Values ----//
function populateItemsAndEraseOtherValues(items, model) {
  items.forEach(item => {
    item.fields = [].concat(model);
  });

  return items;
}


          

